<script>
import { mapState } from "vuex";

// Laisse le temps d'enregistrer ou de prolonger avant la fin de session
const avanceAvertissementMs = 5 * 60 * 1000;
// Un minuteur unique serait retardé dans un onglet en arrière-plan : on recalcule chaque seconde
const intervalleHorlogeMs = 1000;

/**
 * Surveille l'échéance de la session de l'utilisateur connecté, sans rien afficher :
 * signale au store l'approche de la fin (la modale de session passe en avertissement)
 * et fait constater la fin par le serveur, qui fait basculer la modale en « session expirée ».
 * Au retour sur l'onglet, l'état de la session est contrôlé pour prévenir avant toute saisie.
 */
export default {
  name: "SurveillanceSession",
  data() {
    return {
      horloge: Date.now(),
    };
  },
  computed: {
    ...mapState(["echeanceSession"]),
    restantMs() {
      if (!this.echeanceSession) {
        return null;
      }
      return this.echeanceSession.expireLe - (this.horloge + this.echeanceSession.decalage);
    },
    finProche() {
      return this.restantMs !== null && this.restantMs <= avanceAvertissementMs;
    },
    echue() {
      return this.restantMs !== null && this.restantMs <= 0;
    },
  },
  watch: {
    echeanceSession() {
      this.horloge = Date.now();
    },
    finProche: {
      // Page ouverte alors que la fin est déjà proche : l'avertissement doit s'afficher d'emblée
      immediate: true,
      handler(val) {
        this.$store.commit("setFinSessionProche", val);
        // Un identify dans un autre onglet a pu renouveler la session : l'échéance connue ici est peut-être dépassée
        if (val) {
          this.$store.dispatch("verifierEtatSession");
        }
      },
    },
    echue(val) {
      if (val) {
        this.$store.dispatch("verifierEtatSession", { expireeSiInjoignable: true });
      }
    },
  },
  mounted() {
    this.minuteur = setInterval(() => {
      this.horloge = Date.now();
    }, intervalleHorlogeMs);
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  },
  beforeUnmount() {
    clearInterval(this.minuteur);
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    this.$store.commit("setFinSessionProche", false);
  },
  methods: {
    /**
     * Au retour sur l'onglet, contrôle la session : les minuteurs ont pu être ralentis en arrière-plan.
     */
    onVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.horloge = Date.now();
        this.$store.dispatch("verifierEtatSession");
      }
    },
  },
  render() {
    return null;
  },
};
</script>
